import { render, staticRenderFns } from "./comp_ProductCard-Design6Small.vue?vue&type=template&id=16388022&scoped=true"
import script from "./comp_ProductCard-Design6Small.vue?vue&type=script&lang=js"
export * from "./comp_ProductCard-Design6Small.vue?vue&type=script&lang=js"
import style0 from "./comp_ProductCard-Design6Small.vue?vue&type=style&index=0&id=16388022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16388022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VHover,VSpacer})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
